import Vue from 'vue';
import Confirm from './Confirm.vue';

const defaults = {
  title: null,
  message: '',
  type: '',
  closeOnClickModal: true,
  closeOnPressEscape: true,
  visible: false,
};
const ConfirmConstructor = Vue.extend(Confirm);

let currentMessage, instance
let messageQueue = []

const defaultCallback = action => {
  if (currentMessage) {
    let callback = currentMessage.callback;
    if (typeof callback === 'function') {
      callback(action);
    }
    if (currentMessage.resolve) {
      if (action === 'confirm') {
        currentMessage.resolve(action);
      } else if (action === 'cancel' && currentMessage.reject) {
        currentMessage.reject(action);
      }
    }
  }
};

// create instance
const initInstance = () => {
  instance = new ConfirmConstructor({
    el: document.createElement('div')
  });
  instance.callback = defaultCallback;
};

// confirm modal rendering
const showNextMessage = () => {
  if (!instance) {
    initInstance();
  }
  instance.action = '';
  if (!instance.visible) {
    if (messageQueue.length > 0) {
      currentMessage = messageQueue.shift()

      let options = currentMessage.options
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }
      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visible = true
      });
    }
  }
};

const MtConfirm = function(options, callback) {
  if (Vue.prototype.$isServer) return;
  if (typeof Promise !== 'undefined') {
    return new Promise((resolve, reject) => { // eslint-disable-line
      messageQueue.push({
        options: Object.assign({}, defaults, MtConfirm.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      });

      showNextMessage();
    });
  } else {
    messageQueue.push({
      options: Object.assign({}, defaults, MtConfirm.defaults, options),
      callback: callback
    });

    showNextMessage();
  }
};

MtConfirm.setDefaults = defaults => {
  MtConfirm.defaults = defaults;
};

MtConfirm.mtAlert = (message, title, options) => {
  return MtConfirm(Object.assign({}, {
    title: title,
    message: message,
    $type: 'alert',
    closeOnPressEscape: false,
    closeOnClickModal: false
  }, options));
};

// click confirm modal button
MtConfirm.mtConfirm = (message, title, options) => {
  return MtConfirm(Object.assign({}, {
    title: title,
    message: message,
    $type: 'confirm',
  }, options));
};

export default MtConfirm;
export { MtConfirm };



// WEBPACK FOOTER //
// ./src/plugins/mtui/confirm/index.js